// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"5fbae4b6","513":"8cb8342d","787":"4232b31e"}[chunkId] + ".chunk.js";
};